module.exports = __webpack_public_path__ + "img/rb-leipzig-logo-icon.dcd6b376.png";